import { ConverterIF } from '@/components/Input/Converter/ConverterIF'
import '@/util/Extension/StringExtensions'

/**
* 半角数字（整数）のみを許容するinputクラス
* 最大値"max"(最小値"min")を指定すると、その範囲チェックも行います。
*/
export default class HalfNumberVersionConverter implements ConverterIF {
    /**
     * @brief	input要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertInputValue(target: HTMLInputElement): string {
        if (undefined == target || null == target) {
            return "";
        }

        // 数値でない場合は空文字で取得されるため、空文字で上書きして初期化しておく。
        if ("" === target.value) {
            return "";
        }

        // フォーマットチェック
        let strValue = target.value;

        // 半角数字以外を取り除く
        strValue = strValue.removeNotHalfNumberDecimal();

        // 最小値・最大値の判定
        if ("" == strValue || null == strValue) {
            // この段階で空白なら一文字目に半角数字が入力されたということ
            return strValue;
        }

        // 整数に変換する。
        return strValue;
    }

    /**
     * @brief	TextArea要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertTextAreaValue(target: HTMLTextAreaElement): string {
        // TextAreaには非対応のため空文字を返す。
        return "";
    }
}